import { schema } from 'normalizr';

export const packageSchema = new schema.Entity('packages');
export const packagesListSchema = new schema.Array(packageSchema);
